import { supabase } from './supabase';
import { Tag } from '../types/tag';

export const getTags = async (): Promise<Tag[]> => {
  const { data, error } = await supabase
    .from('tags')
    .select('*')
    .order('name', { ascending: true });
  if (error) { console.error('Error fetching tags:', error); return []; }
  return (data as Tag[]) || [];
};

export const createTag = async (name: string, color: string): Promise<Tag | null> => {
  const { data, error } = await supabase
    .from('tags')
    .insert({ name, color })
    .select()
    .single();
  if (error) { console.error('Error creating tag:', error); return null; }
  return data as Tag;
};

export const updateTag = async (id: string, updates: Partial<Pick<Tag, 'name' | 'color'>>): Promise<boolean> => {
  const { error } = await supabase.from('tags').update(updates).eq('id', id);
  if (error) { console.error('Error updating tag:', error); return false; }
  return true;
};

export const deleteTag = async (id: string): Promise<boolean> => {
  const { error } = await supabase.from('tags').delete().eq('id', id);
  if (error) { console.error('Error deleting tag:', error); return false; }
  return true;
};

export const getAllLeadTagsMap = async (): Promise<Map<string, Tag[]>> => {
  const { data, error } = await supabase
    .from('lead_tags')
    .select('lead_id, tags(*)');
  if (error) { console.error('Error fetching all lead tags:', error); return new Map(); }
  const map = new Map<string, Tag[]>();
  for (const row of (data || []) as any[]) {
    if (!row.tags) continue;
    const existing = map.get(row.lead_id) || [];
    map.set(row.lead_id, [...existing, row.tags as Tag]);
  }
  return map;
};

export const getLeadTags = async (leadId: string): Promise<Tag[]> => {
  const { data, error } = await supabase
    .from('lead_tags')
    .select('tags(*)')
    .eq('lead_id', leadId);
  if (error) { console.error('Error fetching lead tags:', error); return []; }
  return (data || []).map((row: any) => row.tags) as Tag[];
};

export const setLeadTags = async (leadId: string, tagIds: string[]): Promise<boolean> => {
  // Delete existing
  const { error: delError } = await supabase.from('lead_tags').delete().eq('lead_id', leadId);
  if (delError) { console.error('Error clearing lead tags:', delError); return false; }
  if (tagIds.length === 0) return true;
  // Insert new
  const rows = tagIds.map(tagId => ({ lead_id: leadId, tag_id: tagId }));
  const { error } = await supabase.from('lead_tags').insert(rows);
  if (error) { console.error('Error setting lead tags:', error); return false; }
  return true;
};
